<template>
<div class="contenido">

 <div class="banG">
            &nbsp;
        </div>
        
  <div class="limitado">
<h2>Umów się na odsłuch:</h2>
<ul>
<li><strong>Audio-ON</strong><br/>ul. Wierzbowa 72<br/>43-502 Czechowice-Dziedzice<br/><a href="https://www.audio-on.pl/27-linemagnetic" target="_blank">https://audio-on.pl/</a></li>
<li><strong>Audiotop</strong><br/>ul. Sycowska 23<br/>60-003 Poznań<br/><a href="https://audiotop.pl/pl/producer/LineMagnetic/785" target="_blank">https://audiotop.pl/</a></li>
<li><strong>AV Świat</strong><br/>ul. Kosiarzy 32<br/>02-953 Warszawa<br/><a href="https://avswiat.pl/pl/producer/Line-Magnetic/47" target="_blank">https://avswiat.pl/</a></li>
<li><strong>Premium Sound</strong><br/>Aleja Niepodległości 645 B<br/>81-855 Sopot<br/><a href="https://www.premiumsound.pl/manufacturer/line-magnetic-audio" target="_blank">https://premiumsound.pl/</a></li>
</ul>

  </div>
  
    </div>
</template>

<script setup>
</script>
